module.exports = __webpack_public_path__ + "img/Djibouti.989eda35.png";